module.exports = __webpack_public_path__ + "static/media/bulgaria.c0020717.svg";